define.alias("shared/utils/formatters/tweet-from-dynamo", "settings/utils/formatters/tweet-from-dynamo");